module.exports = __webpack_public_path__ + "static/media/wwhackingfest.86cdec94.png";